<!--工单详情上部信息-->
<template>
	<div class="dayInfoBody usePowerUnitDiv">
		<div class="searchContainer">
			<el-form ref="form" label-width="90px" style="display: flex;align-items: center;">
				<el-form-item v-bind:label="state">
					<el-button @click="backList()" size="small" type="primary">返回列表</el-button>
					<el-button v-if="seen && workorderStatus == 2" @click="closeDialog()" size="small" type="primary">关闭工单</el-button>
				</el-form-item>
			</el-form>
		</div>
		<div class="topLeftTitleContent">统计信息</div>
		<div class="dayInfoContent bodyBorder">
			<div class="divbody">
				<div class="column">
					<div class="usePowerUnitBlock">
						<p class="usePowerUnitBoxTitle">生产效率</p>
						<p class="usePowerUnitBoxInfo">{{efficiency}}</p>
					</div>
					<div class="usePowerUnitBlock">
						<p class="usePowerUnitBoxTitle">设备数</p>
						<p class="usePowerUnitBoxInfo">{{deviceCount}}</p>
					</div>
				</div>
				<div class="column">
					<div class="usePowerUnitBlock">
						<p class="usePowerUnitBoxTitle">事件数</p>
						<p class="usePowerUnitBoxInfo">{{eventsCount}}</p>
					</div>
					<div class="usePowerUnitBlock">
						<p class="usePowerUnitBoxTitle">耗电量</p>
						<p class="usePowerUnitBoxInfo">{{energy}}</p>
					</div>
				</div>
				<div class="column">
					<div class="usePowerUnitBlock">
						<p class="usePowerUnitBoxTitle">产量</p>
						<p class="usePowerUnitBoxInfo">{{capacity}}</p>
					</div>
				</div>
			</div>
			<div class="divbody" style="height:100%;">
				<WorkorderEvents ref="workorderEvents" v-bind:events="events"></WorkorderEvents>
			</div>
		</div>
		<closeWorkorderDialog ref='closeWorkorderDialog' @closeSuccess="closeSuccess"></closeWorkorderDialog>
	</div>
</template>

<script>
	import canvasCircle from '@/page/unitProfile/canvasCircle.vue'
	import vchart from '@/components/module/chart/vchart.vue'
	import WorkorderEvents from '@/page/projectDingZhi/ningbo/WorkorderDetailEvents.vue'
	import closeWorkorderDialog from '@/page/projectDingZhi/ningbo/dialogs/closeWorkorderDialog.vue'
	import ningboStore from '@/page/projectDingZhi/ningbo/ningboStore.js'
	export default {
		components: {
			canvasCircle,
			vchart,
			WorkorderEvents,
			closeWorkorderDialog,
		},
		props: [],
		data() {
			return {
				efficiency: 0,
				deviceCount: 0,
				eventsCount: 0,
				energy: 0,
				capacity: 0,
				events: [],
				dayMaxNeed: 0,
				monthMaxNeed: 0,
				dayMaxLoad: 0,
				monthMaxLoad: 0,
				todayLoadLine: [],
				nowLoadDeviceFromname: "",
				loadDeviceList: [],
				deviceNoToArchivesInfo: {},
				lineOption: {
					xAxis: {
						type: 'category',
					},
					yAxis: {
						type: 'value'
					},
					series: []
				},
				seen: true,
				state: "工单进行中",
			}
		},
		created() {},
		mounted() {
			this.search();
		},
		destroyed() {
		},
		computed: {
			workorderId(){
				return ningboStore.state.workorder.id + "";
			},
			workorderStatus(){
				return ningboStore.state.workorder.status;
			}
		},
		watch: {
		},
		methods: {
			search() {
				this.getWorkorderList()
			},
			getWorkorderList() {
				this.$api.ningboApi.orderDetail(
					this.workorderId, respon => {
						this.efficiency = respon["efficiency"];//: 345,//生产效率
						this.deviceCount = respon["deviceCount"];//: 3,//设备数
						this.eventsCount = respon["eventsCount"];//: 0,//事件数
						this.energy = respon["energy"];//: 345,//耗电量
						this.capacity = respon["capacity"];//: 23.4//产能
						this.events = respon["events"];//: [],//事务

						if(this.efficiency.length == 0){
							this.efficiency = '0';
						}
						if(this.deviceCount.length == 0){
							this.deviceCount = '0';
						}
						if(this.eventsCount.length == 0){
							this.eventsCount = '0';
						}
						if(this.energy.length == 0){
							this.energy = '0';
						}
						if(this.capacity.length == 0){
							this.capacity = '0';
						}
					}
				);
			},
			backList(){
				this.$router.push('/ningboWorkorderList')
			},
			closeDialog() {
				this.$refs.closeWorkorderDialog.title="关闭工单"
				this.$refs.closeWorkorderDialog.id = this.workorderId;
				this.$refs.closeWorkorderDialog.isEdit=true
				this.$refs.closeWorkorderDialog.show=true
			},
			closeSuccess() {
				this.state = '工单已关闭';
				this.seen = false;
			}
		}
	}
</script>

<style scoped>
	@import url("../../../components/css/usePowerUnit.css");
	.divbody>>>.default-chart {
		height: 100%;
		width: 100%;
	}
	
	.dayInfoBody {
		height: 100px;
	}
	
	.dayInfoContent {
		display: flex;
		align-items: center;
		height: 80%;
	}
	
	.divbody {
		padding: 10px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 48.5%;
		height: calc(100% - 20px);
	}
	
	.column {
		width: 30%;
		display: flex;
		flex-direction: column;
		height: 100%;
	}

	.usePowerUnitBlock {
		margin: 10px;
	}
	
	.info {
		font-size: 16px;
		font-family: "黑体";
	}
	
	.circle {
		width: 100%;
	}
	
	@media screen and (max-width: 1200px) {
		.dayInfoContent {
			display: flex;
			justify-content: flex-start;
			align-items: flex-start;
			flex-wrap: wrap;
		}
		
		.divbody {
			width: 100%;
			height: 250px;
		}
	}
</style>